import React from 'react'
import PropTypes from 'prop-types'
import { CompositeDecorator } from 'draft-js'

import { List } from 'immutable'

const Span = props => <span>{props.children}</span>

Span.propTypes = {
  children: PropTypes.oneOfType([PropTypes.array.isRequired, PropTypes.object.isRequired])
}

export default class CompoundDecorator {
  constructor(decorators = []) {
    this.decorators = decorators.map(decorator =>
      decorator.strategy && decorator.component ? new CompositeDecorator([decorator]) : decorator
    )
  }

  getDecorations(block, contentState) {
    const emptyTuples = Array.from({ length: block.getText().length }).fill(
      Array.from({ length: this.decorators.length }).fill(null)
    )
    const decorations = this.decorators.reduce((tuples, decorator, index) => {
      const blockDecorations = decorator.getDecorations(block, contentState)

      return tuples.map((tuple, tupleIndex) => [
        ...tuple.slice(0, index),
        blockDecorations.get(tupleIndex),
        ...tuple.slice(index + 1)
      ])
    }, emptyTuples)

    return List(decorations.map(JSON.stringify))
  }

  getComponentForKey(key) {
    const tuple = JSON.parse(key)
    // eslint-disable-next-line react/display-name
    return props => {
      // eslint-disable-next-line react/prop-types
      const { decoratorProps, children, ...compositionProps } = props
      const Composed = tuple.reduce((Composition, decoration, index) => {
        if (decoration !== null) {
          const decorator = this.decorators[index]
          const Component = decorator.getComponentForKey(decoration)
          const componentProps = {
            ...compositionProps,
            ...decoratorProps[index]
          }
          // eslint-disable-next-line react/display-name
          return () => (
            <Component {...componentProps}>
              <Composition {...compositionProps} />
            </Component>
          )
        }
        return Composition
      }, Span)
      return <Composed>{children}</Composed>
    }
  }

  getPropsForKey(key) {
    const tuple = JSON.parse(key)
    return {
      decoratorProps: tuple.map((decoration, index) => {
        const decorator = this.decorators[index]
        return decoration !== null ? decorator.getPropsForKey(decoration) : {}
      })
    }
  }
}
